import { useFeatureFlags, usePermissions, validateRestriction } from '@procureai/permissions-ui';
import { complement } from 'ramda';

import { BaseModule, Module, ModuleSlotId } from '~/modules';

export type ModuleSlotProps = {
  id: ModuleSlotId;
  modules?: BaseModule[];
  [key: string]: any;
};

export const ModuleSlot = ({ id, modules, moduleAfter, ...otherProps }: ModuleSlotProps) => {
  const { hasPermission } = usePermissions();
  const { hasFeatureFlag } = useFeatureFlags();

  const allowedModules = modules?.filter(
    (module) =>
      validateRestriction(module.needs, hasPermission, hasFeatureFlag) &&
      validateRestriction(module.lacks, complement(hasPermission), complement(hasFeatureFlag)),
  );
  return (
    <>{allowedModules && allowedModules.map((module) => <Module key={module.id} {...otherProps} {...module} />)}</>
  );
};
